import { render } from "./MilkList.vue?vue&type=template&id=ab56d956&ts=true"
import script from "./MilkList.vue?vue&type=script&lang=ts"
export * from "./MilkList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__